/* eslint-disable no-unused-vars, eqeqeq */
import { getAuth, sendPasswordResetEmail, fetchSignInMethodsForEmail } from "firebase/auth";
import { app } from "../config";
import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";

const auth = getAuth(app);
const db = getFirestore(app)

const checkUserSignInMethod = (user) => {
  if (user && user.providerData) {
    // Loop through providerData to check the provider used
    const providerData = user.providerData;
    let signInMethod = null;

    providerData.forEach((provider) => {
      if (provider.providerId === "google.com") {
        signInMethod = "Google";
      } else if (provider.providerId === "password") {
        signInMethod = "Email";
      }
    });

    return signInMethod;
  } else {
    console.log("No user is signed in.");
    return null;
  }
};



const checkEmailExistsAndSignUpMethod = async (inputEmail) => {
  try {
    // Reference the 'users' collection and create a query to find the email
    const usersRef = collection(db, "users");
    const q = query(usersRef, where("email", "==", inputEmail));

    // Execute the query
    const querySnapshot = await getDocs(q);

    // Check if any documents match the email (Firestore check)
    if (querySnapshot.empty) {
      console.log(`Email ${inputEmail} does not exist.`);
      return { exists: false, message: `Email ${inputEmail} does not exist.` };
    }

    // Get the user document and retrieve the 'signUpMethod' field
    const userDoc = querySnapshot.docs[0]; // Assuming emails are unique
    const userData = userDoc.data();
    const signUpMethod = userData.signUpMethod; // Fetch signUpMethod field

    // Check if the signUpMethod is 'Google'
    if (signUpMethod === "Google") {
      return { exists: true, signUpMethod: "Google", message: "Cannot reset password for Google accounts." };
    }

    // Check if the signUpMethod is 'Email'
    if (signUpMethod === "Email") {
      return { exists: true, signUpMethod: "Email", message: "Email/Password sign-up method." };
    }

    // If signUpMethod is not recognized
    return { exists: true, signUpMethod: "Unknown", message: "Unknown sign-up method." };

  } catch (error) {
    console.error("Error checking email and sign-up method: ", error);
    throw new Error("Error checking email and sign-up method.");
  }
};

// Function to handle "Forgot Password" by sending a password reset email
const forgotPassword = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    console.log("Password reset email sent successfully.");
    return { success: true, message: "Password reset email sent successfully." };
  } catch (error) {
    if (error.code === "auth/user-not-found") {
      return { success: false, message: "No account with this email found." };
    } else {
      return { success: false, message: error.message };
    }
  }
};

// Main handler to check if the email exists before running the forgot password process
const handleForgotPassword = async (email, user) => {
  try {
    // Check if email exists
    const emailCheckResult = await checkEmailExistsAndSignUpMethod(email);
    if (!emailCheckResult.exists) {
      return { success: false, message: "No account found with the provided email." };
    }
    if (emailCheckResult.signUpMethod === "Google") {
      return { success: false, message: "Cannot reset password for a Google Account" };
    }

    const signInMethod = checkUserSignInMethod(user)
    console.log("sign in method", signInMethod)
    if (signInMethod === "Google") {
      return { success: false, message: "Cannot access forgot password for Google Account" };
    }

    const forgotPasswordResult = await forgotPassword(email);
    if (forgotPasswordResult.success) {
      return { success: true, message: "Password reset email sent successfully." };
    } else {
      return { success: false, message: "Failed to send the password reset email." };
    }
  } catch (error) {
    console.error("Error handling forgot password:", error);
    return { success: false, message: "Error handling forgot password." };
  }
};
export { handleForgotPassword }